import { createSlice } from "@reduxjs/toolkit";

const initialStates = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    paymentEntities: [],
    payment: undefined,
    lastError: null,
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const paymentSlice = createSlice({
    name: "payment",
    initialState: initialStates,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        paymentListFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.paymentEntities = action.payload.paymentEntities;
            state.totalCount = action.payload.totalCount;
            state.error = null;
        },
        paymentFetched: (state, action) => {
            state.actionsLoading = false;
            state.payment = action.payload.payment;
            state.error = null;
        },
    }
})